import React from "react";
import { BrandLoader } from "../../components/Brand";
import styles from "./OrderInitiatePage.module.css";

const PlaceOrderIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
    <path
      d="M9.3125 12.3752L6.6875 9.75022M9.3125 12.3752C10.5347 11.9104 11.7073 11.3241 12.8125 10.6252M9.3125 12.3752V16.7502C9.3125 16.7502 11.9637 16.269 12.8125 15.0002C13.7575 13.5827 12.8125 10.6252 12.8125 10.6252M6.6875 9.75022C7.15313 8.54222 7.73943 7.38427 8.4375 6.29397C9.45703 4.66383 10.8767 3.32163 12.5614 2.39505C14.2461 1.46846 16.1398 0.988292 18.0625 1.00022C18.0625 3.38022 17.38 7.56272 12.8125 10.6252M6.6875 9.75022L2.3125 9.75023C2.3125 9.75023 2.79375 7.09898 4.0625 6.25023C5.48 5.30523 8.4375 6.25023 8.4375 6.25023M2.75 13.6878C1.4375 14.7903 1 18.0628 1 18.0628C1 18.0628 4.2725 17.6253 5.375 16.3128C5.99625 15.5778 5.9875 14.449 5.29625 13.7665C4.95614 13.4419 4.50813 13.2543 4.0382 13.2398C3.56826 13.2253 3.10952 13.3848 2.75 13.6878Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function StickyFooter({
  selectedScripCount,
  selectedBasketCount,
  totalClientsCount,
  clientSelectionPhase = "browse",
  canGoNext = false,
  canPlaceOrder,
  isPlacingOrder = false,
  onNext,
  onBack,
  onPlaceOrder,
}) {
  const isReview = clientSelectionPhase === "selectedReview";
  const nextDisabled = !canGoNext;
  const placeDisabled = !canPlaceOrder || isPlacingOrder;

  return (
    <div className={styles.stickyFooter}>
      <div className={styles.footerStats}>
        <div className={styles.footerStatBlock}>
          <div className={styles.footerStatLabel}>Selected Scrip</div>
          <div className={styles.footerStatValue}>{selectedScripCount} Scrips</div>
        </div>
        <div className={styles.footerStatSeparator} />
        <div className={styles.footerStatBlock}>
          <div className={styles.footerStatLabel}>Selected Basket</div>
          <div className={styles.footerStatValue}>{selectedBasketCount} Baskets</div>
        </div>
        <div className={styles.footerStatSeparator} />
        <div className={styles.footerStatBlock}>
          <div className={styles.footerStatLabel}>Total Clients</div>
          <div className={styles.footerStatValue}>{totalClientsCount} Clients</div>
        </div>
      </div>
      <div className={styles.footerActions}>
        {isReview ? (
          <>
            <button type="button" className={styles.footerBackBtn} onClick={onBack}>
              Back
            </button>
            <button
              type="button"
              className={styles.primaryBtn}
              disabled={placeDisabled}
              aria-disabled={placeDisabled}
              onClick={onPlaceOrder}
            >
              <span className={styles.primaryBtnIcon}>
                {isPlacingOrder ? (
                  <BrandLoader variant="icon" size={16} />
                ) : (
                  <PlaceOrderIcon />
                )}
              </span>
              {isPlacingOrder ? "Placing order…" : "Place Order"}
            </button>
          </>
        ) : (
          <button
            type="button"
            className={styles.primaryBtn}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            onClick={onNext}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}

export default React.memo(StickyFooter);
